<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoInserir">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoInserir">
			<form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="tipo">Tipo</label>
							<p-dropdown [options]="tiposOrcamento" optionLabel="label" optionValue="value"
								emptyFilterMessage="Nenhum registro" name="tipo" ngModel #tipo="ngModel"
								[(ngModel)]="tipoOrcamentoSelecionado" (ngModelChange)="verificarClienteSemCpf()">
							</p-dropdown>
						</div>

						<div class="field col-12 md:col-2">
							<label htmlFor="dataOrcamento">Data da Proposta</label>
							<p-calendar [showIcon]="true" [showOnFocus]="false" dateFormat="dd/mm/yy"
								[showButtonBar]="true" name="dataOrcamento" ngModel #dataOrcamento="ngModel"
								[required]="true" [(ngModel)]="orcamento.dataOrcamento">
							</p-calendar>
						</div>

						<div class="field col-12 md:col-6">
							<label>Interessado</label>
							<div class="p-inputgroup">
								<label class="form-control-agrupado">{{nomeClienteSelecionado}}</label>
								<button type="button" pButton pRipple
									[icon]="clienteSelecionado ? 'pi pi-pencil' : 'pi pi-plus'" pTooltip="Selecione"
									class="p-button-success" style="box-shadow: none;" (click)="abrirDialogCliente()">
								</button>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="validadeProposta">Validade (dias)</label>
							<input type="number" pInputText name="validadeProposta" ngModel
								#validadeProposta="ngModel" [(ngModel)]="orcamento.validadeProposta"/>
						</div>
						<div class="form-group field col-12 md:col-2">
							<label>Valor da Proposta</label>
							<label class="form-control" id="valorProposta">{{ valorProposta | currency:'BRL'
								}}</label>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="desconto">Desconto</label>
							<p-inputNumber suffix="%" name="desconto" ngModel #desconto="ngModel" [max]="100"
								[allowEmpty]="false" [minFractionDigits]="2" [maxFractionDigits]="2"
								[(ngModel)]="valorDescontoTotal" (ngModelChange)="calcularValorProposta()">
							</p-inputNumber>
						</div>
						<div class="field col-12 md:col-8">
							<label htmlFor="condicaoPagamento">Condicão do Pagamento</label>
							<input type="text" pInputText name="condicaoPagamento" ngModel
								#condicaoPagamento="ngModel" [(ngModel)]="orcamento.condicaoPagamento"/>
						</div>
						<div class="field col-12 md:col-12" *ngIf="clienteSelecionado">
							<p-table #tbItensAdicionados [value]="listaItensOrcamento" dataKey="id" [rows]="10"
								[rowHover]="true" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="caption">
									<div class="flex justify-content-start flex-column sm:flex-row">
										<button pButton pRipple class="p-button-primary" pTooltip="Adicionar Item ao Pacote"
										 icon="pi pi-shopping-cart" style="box-shadow: none;" type="button"
										  (click)="abrirDialogItem()">
										</button>
										
									</div>
								</ng-template>
								
								<ng-template pTemplate="header">
									<tr>
										<th>Descrição</th>
										<th>Quantidade</th>
										<th>Valor Unitário</th>
										<th>Desconto Item</th>
										<th>Valor Total</th>
										<th>Excluir</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item let-i="rowIndex">
									<tr>
										<td>
											<label>{{ item.nomeItem }}</label>
										</td>
										<td>
											<input type="text" name="quantidade{{i}}" pInputText
												[(ngModel)]="item.quantidadeProposta" (input)="calcularValorTotal()" />
										</td>
										<td>
											<p-inputNumber name="valorUnitario{{i}}" [allowEmpty]="false"
												[(ngModel)]="item.valorUnitario" mode="currency"
												inputId="currency-brazil" currency="BRL" locale="pt-BR"
												(onBlur)="calcularValorTotal()">
											</p-inputNumber>
										</td>
										<td>
											<p-inputNumber suffix="%" name="desconto{{i}}" [max]="100"
												[minFractionDigits]="2" [maxFractionDigits]="2" [allowEmpty]="false"
												[(ngModel)]="item.descontoItem" (onBlur)="calcularValorTotal()">
											</p-inputNumber>
										</td>
										<td>
											<label class="form-control">{{ (item.quantidadeProposta *
												item.valorUnitario)
												- ((item.quantidadeProposta * item.valorUnitario)
												* (item.descontoItem / 100)) | currency:'BRL' }}</label>
										</td>

										<td>
											<button pButton pRipple pTooltip="Excluir" type="button" icon="pi pi-trash"
												class="p-button-danger" (click)="removerItemOrcamento(i)">
											</button>
										</td>
									</tr>

								</ng-template>
								<ng-template pTemplate="summary">
									<div class="flex align-items-center justify-content-between">
										<div>
											Há {{listaItensOrcamento ? listaItensOrcamento.length : 0 }} itens inseridos
											na Proposta.
										</div>
										<div>
											Total: {{ valorTotalItens | currency:'BRL' }}
										</div>
									</div>
								</ng-template>
							</p-table>
						</div>
					</div>

					<div class="p-fluid p-formgrid grid justify-content-between">
						<div class="field col-12 md:col-4" >
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="button" pButton icon="pi pi-check" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid || !clienteSelecionado
								 || !valorProposta" (click)="salvar()">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="button" pButton icon="pi pi-spin pi-spinner" label="salvar"
								class="p-button-outlined p-button-success md:w-9rem" [disabled]="true">
								</button>
							</ng-template>
						</div>
						<div class="field col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/orcamentos-e-pacotes"></button>
						</div>
					</div>
				</div>
			</form>
			<p-dialog header="Cadastrar Cliente" [(visible)]="exibirDialogCadastroCliente" [modal]="true"
				[style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="false">
				<form #formCliente="ngForm" name="formCliente">
					<div class="formgroup">
						<div class="p-fluid p-formgrid grid">

							<div class="field col-12 md:col-8">
								<label htmlFor="nome">Nome</label>
								<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
									placeholder="Digite o nome e sobrenome" name="nome" ngModel #nome="ngModel" />
							</div>
							<div class="field col-12 md:col-4">
								<label htmlFor="apelido">Apelido</label>
								<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
									placeholder="Digite o apelido" name="apelido" ngModel #apelido="ngModel" />
							</div>
							<div class="field col-12 md:col-3">
								<label htmlFor="cpf">CPF</label>
								<p-inputMask mask="999.999.999-99" [unmask]="true" type="text"
									placeholder="000.000.000-00" name="cpf" ngModel #cpf="ngModel"> </p-inputMask>
								<!-- <div *ngIf="clienteCpfEncontrado" class="alerta">
									<small>CPF Informado já existe</small>
								</div> -->
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="aniversario">Aniversário</label>
								<p-inputMask mask="99/99" type="text" placeholder="DD/MM" name="aniversario" ngModel
									#aniversario="ngModel"> </p-inputMask>
								<!-- <div *ngIf="!dataValida" class="alerta">
									<small>Data inválida</small>
								</div> -->
							</div>
							<div class="field col-12 md:col-4">
								<label htmlFor="email">E-mail</label>
								<input pInputText type="email" placeholder="seuemail@mail.com" name="email" ngModel
									email="true" #email="ngModel" />
								<div *ngIf="email.hasError('email')" class="alerta">
									<small>Digite um e-mail válido</small>
								</div>
							</div>

							<div class="field col-12 md:col-3">
								<label htmlFor="telefone">Telefone</label>
								<p-inputMask mask="(99) 99999-9999" [unmask]="true" type="text"
									placeholder="(99) 99999-9999" name="telefone" ngModel #telefone="ngModel"
									[required]="true">
								</p-inputMask>

							</div>
						</div>
					</div>
				</form>

				<div class="p-fluid p-formgrid grid justify-content-between">
					<div class="field col-12 md:col-3" *ngIf="!requisicaoCadastroCliente">
						<button type="button" pButton icon="pi pi-check" label="Cadastrar" class="p-button-success"
							(click)="cadastrarCliente(formCliente.form)">
						</button>
					</div>
					<div class="field col-12 md:col-3" *ngIf="requisicaoCadastroCliente">
						<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Cadastrando..."
							class="p-button-success mt-5" [disabled]="true"></button>
					</div>
					<div class="field col-12 md:col-3">
						<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-primary"
							(click)="fecharDialogCadastroCliente()"></button>
					</div>
				</div>
			</p-dialog>
			<p-dialog header="Clientes" [(visible)]="exibirDialogCliente" [modal]="true" [draggable]="false"
				[resizable]="false" [closable]="true" (onHide)="fecharDialogCliente()">

				<div class="flex justify-content-center" *ngIf="exibirSpinnerDialogCliente">
					<p-progressSpinner></p-progressSpinner>
				</div>

				<div class="card" *ngIf="!exibirSpinnerDialogCliente">
					<button pButton pRipple label="Novo" (click)="abrirDialogCadastroCliente()" icon="pi pi-plus"
						class="p-button-info mr-2 mb-2">
					</button>

					<p-table #tbDialogCliente [value]="listaClientes" dataKey="id"
						[rows]="itensClientesPaginados ? itensClientesPaginados.size : 0" [loading]="loadingTable"
						[rowHover]="true" [paginator]="true" (onPage)="onPageChangeCliente($event)"
						[totalRecords]="itensClientesPaginados ? itensClientesPaginados.totalElements : 0" [lazy]="true"
						[showCurrentPageReport]="true" responsiveLayout="scroll" styleClass=" p-datatable-sm"
						currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
						<ng-template pTemplate="caption">
							<div class="flex justify-content-end flex-column sm:flex-row">

								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text" #filter (input)="buscarDialogCliente($event)"
											placeholder="Buscar" class="w-full" />
									</span>
									<span class="ml-2">
										<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
											pTooltip="Limpar Filtros" (click)="limparDialogCliente()"></button>
									</span>
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="nome">
									Nome
									<p-sortIcon field="nome">
									</p-sortIcon>
								</th>
								<th pSortableColumn="apelido">
									Apelido
									<p-sortIcon field="apelido">
									</p-sortIcon>
								</th>
								<th pSortableColumn="cpf">
									CPF
									<p-sortIcon field="cpf">
									</p-sortIcon>
								</th>
								<th style="text-align: center;">
									Selecionar
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item>
							<tr>
								<td>
									{{item.nome}}
								</td>
								<td>
									{{item.apelido}}
								</td>
								<td>
									{{item.cpf ? (item.cpf | cpfPipe ) : 'NÃO CADASTRADO'}}
								</td>
								<td style="text-align: center;">
									<button pButton pRipple (click)="selecionarCliente(item)" icon="pi pi-plus"
										class="p-button-info mr-2 mb-2">
									</button>
								</td>

							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Nenhum registro encontrado.</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="loadingbody">
							<tr>
								<td colspan="7">Carregando clientes. Por favor aguarde.</td>
							</tr>
						</ng-template>
					</p-table>

				</div>
				<p-footer>
					<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
						(click)="fecharDialogCliente()"></button>
				</p-footer>
			</p-dialog>
			<p-dialog [header]="tipoOrcamentoSelecionado === 'PACOTE' ? 'Adicionar Serviço':'Adicionar Produto/Serviço'"
				[(visible)]="exibirDialogItem" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true">
				<div class="card">
					<div class="flex justify-content-center" *ngIf="exibirSpinnerDialogItem">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<p-table #tbItensDialog [value]="listaItensDialog" dataKey="id" [rows]="10" [rowHover]="true"
						styleClass="p-datatable-gridlines" [paginator]="true" responsiveLayout="scroll"
						styleClass=" p-datatable-sm" [globalFilterFields]="['codigo', 'descricao']"
						[loading]="loadingItensDialog" *ngIf="!exibirSpinnerDialogItem">
						<ng-template pTemplate="caption">
							<div class="flex justify-content-between flex-column sm:flex-row">
								<p-dropdown *ngIf="tipoOrcamentoSelecionado !== 'PACOTE'" [options]="tiposItem"
									optionLabel="label" optionValue="value" emptyFilterMessage="Nenhum registro"
									name="situacao" ngModel #situacao="ngModel" [(ngModel)]="tipoItemSelecionado"
									(onChange)="carregarItens()">
								</p-dropdown>
								<div *ngIf="tipoOrcamentoSelecionado === 'PACOTE'"></div>
								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text" #filter (input)="buscar(tbItensDialog, $event)"
											placeholder="Buscar" class="w-full" />
									</span>
									<span class="ml-2">
										<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
											pTooltip="Limpar Filtros" (click)="limpar(tbItensDialog)"></button>
									</span>
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="codigo">
									<div>
										Código
									</div>
								</th>
								<th pSortableColumn="descricao">
									<div>
										Descrição
									</div>
								</th>
								<th>
									<div>
										Estoque atual
									</div>
								</th>

								<th style="text-align: center;">
									<div>
										Selecionar
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item let-i="rowIndex">
							<tr>
								<td>
									<label>{{ item.codigo }}</label>
								</td>
								<td>
									<label>{{ item.descricao }}</label>
								</td>
								<td>
									<label>{{ item.estoqueAtual }} {{ item.descricaoUnidadeMedida }}</label>
								</td>

								<td style="text-align: center;">
									<button pButton pRipple pTooltip="Adicionar" type="button" icon="pi pi-check"
										class="p-button-success" (click)="adicionarItem(item)">
									</button>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="summary">
							<div class="flex align-items-center justify-content-between">
								Há {{listaItensDialog ? listaItensDialog.length : 0 }} Itens
								disponíveis.
							</div>
						</ng-template>
					</p-table>

				</div>
				<p-footer>
					<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
						(click)="exibirDialogItem = false"></button>
				</p-footer>
			</p-dialog>
			<!-- <p-dialog header="Cliente Sem CPF" [(visible)]="exibirRedirecionarCliente" [modal]="true"
                [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true"
                >
                <div class="flex justify-content-between">
                    <p>
                        CPF do Cliente obrigatório. Deseja atualizar o cadastro do Cliente?
                    </p>
					<div>

						<button type="button" pButton label="Não" class="p-button-primary mr-2"
							(click)="exibirRedirecionarCliente = false"></button>
						<button type="button" pButton label="Sim" class="p-button-primary"
							(click)="redirecionarClienteSemCpf()"></button>
					</div>

                </div>
            </p-dialog> -->
			<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"
				rejectButtonStyleClass="p-button-text"></p-confirmDialog>
		</div>
	</div>
</div>